/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import { getTopologyRoomData } from "../multiplayer/SocketConnection"
import { JOB_ROOM, TOPOLOGY_ROOM } from "../rooms/RoomNameConstants"
import { CENTER_GRAPH } from "../store/constants/homeFields"
import { setCenterGraph } from "../store/slice/centerGraphSlice"
import { changeRoom, goToPreviousRoom, setCache } from "../store/slice/roomSlice"
import store from "../store/store"

export const changeRoomHandler = (
    targetRoom,
    setupCallback,
    dataToCache = null,
) => {
    const state = store.getState()
    const dispatch = store.dispatch

    const currentRoom = state.room.history[0].ID

    if (setupCallback instanceof Function) setupCallback();

    dispatch(changeRoom(targetRoom))

    if (!!dataToCache) {
        const { key, data, callback } = dataToCache
        const cache = {
            room: currentRoom,
            data,
            key,
            callback,
        }

        dispatch(setCache(cache))
    }
}

export const previousRoomHandler = () => {
    const previousRoom = store.getState().room.history[1]
    const selectedJob = store.getState().jobroom.selectedJob

    if (previousRoom.ID === JOB_ROOM) getTopologyRoomData({
        selectedJob,
        targetRoom: TOPOLOGY_ROOM
    })

    if (!!previousRoom.cache) {
        let callback

        Object.keys(previousRoom.cache).forEach((key) => {
            callback = previousRoom.cache[key].callback
            if (callback instanceof Function) callback(previousRoom.cache[key])
            if (key === CENTER_GRAPH) store.dispatch(setCenterGraph(previousRoom.cache[key]))
        })
    }

    store.dispatch(goToPreviousRoom())
}